import { useState } from 'react';

import DepartmentHeader from './DepartmentHeader';
import OrganizationTabs from './OrganizationTabs';
import DepartmentToolbar from './DepartmentToolbar';
import DepartmentTable from './DepartmentTable';
import AddDepartmentDrawer from './AddDepartmentDrawer';

const DepartmentPage = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <DepartmentHeader onAddDepartment={() => setIsDrawerOpen(true)} />

      <OrganizationTabs />

      <div className="department-content-card">
        <DepartmentToolbar />
        <DepartmentTable />
      </div>

      <AddDepartmentDrawer open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} />
    </>
  );
};

export default DepartmentPage;
